import { Field, Label, Radio, RadioGroup } from "@headlessui/react";
import type { Signal } from "@preact/signals";
import { Icons } from "#palette/icons";

/**
 * RadioOption renders a single radio button for the user to click on. It is not exported since it must be used in a
 * RadioOptionGroup to be really useful.
 */
function RadioOption(props: { value: string }) {
  return (
    <Field key={props.value} className="">
      <Radio
        value={props.value}
        className="flex items-center gap-2 my-2 justify-between rounded border border-brand-50 bg-brand-0 p-3 shadow-sm hover:bg-brand-50 data-[checked]:border-brand-0 data-[checked]:bg-brand-50 group"
      >
        <Label className="text-sm font-bold !m-0">{props.value}</Label>
        <Icons.OK className="flex-none hidden w-5 h-5 group-data-[checked]:block" />
      </Radio>
    </Field>
  );
}

/**
 * RadioOptionGroup renders a set of mutually-exclusive options for the user to select.
 */
export function RadioOptionGroup(props: {
  options: string[];
  selected: Signal<string>;
}) {
  return (
    <RadioGroup
      value={props.selected.value}
      onChange={(value) => {
        props.selected.value = value;
      }}
    >
      {props.options.map((item) => (
        <RadioOption value={item} />
      ))}
    </RadioGroup>
  );
}
